/** An on/off switch on the dashboards tokens. Label it with `aria-labelledby` or `aria-label`. */
export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  'aria-describedby'?: string;
  disabled?: boolean;
}

export function Switch({ checked, onChange, disabled = false, ...aria }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      {...aria}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: 44,
        height: 26,
        flex: '0 0 44px',
        borderRadius: 999,
        padding: 3,
        position: 'relative',
        background: checked ? 'var(--nb-primary)' : 'var(--nb-border-2)',
        transition: 'background .15s',
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : undefined,
      }}
    >
      <i
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 3,
          left: checked ? 21 : 3,
          width: 20,
          height: 20,
          borderRadius: 999,
          background: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,.25)',
          transition: 'left .15s',
        }}
      />
    </button>
  );
}
